import { render, staticRenderFns } from "./Slider.vue?vue&type=template&id=7168fddb&scoped=true"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"
import style0 from "./Slider.vue?vue&type=style&index=0&id=7168fddb&prod&lang=scss&scoped=true"
import style1 from "./Slider.vue?vue&type=style&index=1&id=7168fddb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7168fddb",
  null
  
)

export default component.exports